<template>
  <div>
    <breadcrumbs></breadcrumbs>

    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="设备类型" prop="serverId" v-if="typeArr.length > 1">
        <el-select
          disabled
          @change="changeEquipmentType"
          v-model="form.serverId"
          placeholder="请选择设备类型"
        >
          <el-option
            v-for="(v, i) in typeArr"
            :key="i"
            :label="v.name"
            :value="v.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
      </el-form-item>
      <el-form-item label="角色场景">
        <el-checkbox-group v-model="form.roleType">
          <el-checkbox
            v-for="(v, i) in sceneInfo"
            :key="i"
            :label="
              v == 1
                ? '景区场景'
                : v == 2
                ? '校园场景'
                : v == 3
                ? '社区场景'
                : ''
            "
            :name="v"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="角色权限">
        <el-tabs v-model="activeTab" type="border-card" @tab-click="lookList">
          <el-tab-pane
            v-for="(v, i) in rolePermission"
            :key="i"
            v-if="form.roleType.indexOf(v) !== -1"
            :label="v"
            :name="v"
            :data="JSON.stringify(v)"
          >
            <!--新增修改界面-->
            <el-form :model="roleForm" label-width="80px">
              <el-form-item prop="menuBtn">
                <!-- <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterTree"
                ></el-input> -->
                <el-tree
                  :filter-node-method="filterNode"
                  :ref="'tree' + i"
                  :data="menulistTreeData"
                  show-checkbox
                  :check-strictly="false"
                  :default-expand-all="false"
                  node-key="key"
                  :default-checked-keys="[]"
                  :props="{
                    label: 'menuName',
                    children: 'children',
                    disabled: 'disabled',
                  }"
                >
                </el-tree>
              </el-form-item>
            </el-form>
            <div class="dialog-footer">
              <el-button @click="$router.push('/sys/role')">取消</el-button>
              <el-button type="primary" @click.native="submit('form', v)"
                >保存</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },

  data() {
    const name = (rule, value, callback) => {
      var reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
      if (!value) {
        callback(new Error("请填写角色名称"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持中英文，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      sceneInfo: [],
      form: {
        name: "",
        roleType: [],
        serverId: "1",
      },
      rolePermission: [], //角色权限
      roleForm: {
        menuBtn: {},
        roleName: "",
      },
      menulistTreeData: [], //树结构
      filterTree: "", //关键字输入查询
      btnlistData: [], //按钮列表
      rules: {
        name: [{ required: true, validator: name, trigger: "blur" }],
        serverId: [
          { required: true, message: "请选择设备类型", trigger: "blur" },
        ],
      },
      treeName: "",
      tree: null,
      roleType: "",
      activeTab: "",
      i: null,
      typeArr: [],
    };
  },
  created() {
    this.getShebeiType();
    console.log(this.$route.query, "传参");
    this.roleType = this.$route.query.roleType;
    this.form.name = this.$route.query.roleName;
    // this.form.serverId = this.$route.query.serverId;
    let arr = this.$route.query.roleTypeName.split(",");
    this.rolePermission = arr;
    let newArr = this.$route.query.roleType.split(",");
    this.sceneInfo = newArr;
    // this.sceneInfo = JSON.parse(localStorage.getItem("sceneInfo"));
    // this.sceneInfo.forEach((v) => {
    //   if (v == 1) {
    //     this.form.roleType.push("景区场景");
    //   } else if (v == 2) {
    //     this.form.roleType.push("校园场景");
    //   } else if (v == 3) {
    //     this.form.roleType.push("社区场景");
    //   } else {
    //     return;
    //   }
    // });
    this.form.roleType = this.rolePermission;
    // this.rolePermission = this.form.roleType;
    this.btnlist();
    console.log("按钮");
    // this.$nextTick((e) => {
    //   this.$refs.tree.setCheckedKeys([]);
    //   console.log(this.$refs.tree, "树2");
    // });
  },
  watch: {
    filterTree(val) {
      if (this.treeName === "景区场景") {
        this.$refs.tree0.filter(val);
      } else if (this.treeName === "校园场景") {
        this.$refs.tree1.filter(val);
      } else {
        this.$refs.tree2.filter(val);
      }
    },
  },
  methods: {
    // 字典表
    getShebeiType() {
      // this.$api.dict.list({ dictName: "服务管理" }).then((res) => {
      //   if (res.code === 200) {
      //     console.log(res, "字典表");
      //     this.typeArr = [];

      //     res.data.forEach((v) => {
      //       if (v.dictPid !== 0) {
      //         this.typeArr.push(v);
      //       }
      //     });
      //   }
      // });
      this.$api.home.serverHttp().then((res) => {
        if (res.code === 200) {
          // this.typeArr = res.data;
          let typeArr = res.data;
          this.getFuwu(typeArr).then((updatedServerArr) => {
            this.typeArr = updatedServerArr;
          });
        }
      });
    },
    getFuwu(n) {
      // 返回一个 Promise
      return new Promise((resolve, reject) => {
        this.$api.dict
          .list({ dictName: "服务管理" })
          .then((res) => {
            if (res.code === 200) {
              let arr = n.map((itemA) => {
                // 在 B 数组中查找匹配的项
                let matchedItemB = res.data.find(
                  (itemB) => itemB.dictValue === itemA.id
                );

                // 如果找到匹配项，更新 itemA 的 name 字段
                if (matchedItemB) {
                  itemA.name = matchedItemB.dictName;
                }

                return itemA;
              });

              // 解析 Promise，返回更新后的数组
              resolve(arr);
            } else {
              // 如果请求失败，拒绝 Promise
              reject(new Error("Failed to fetch dictionary list."));
            }
          })
          .catch((error) => {
            // 捕获并处理任何网络错误或其他异常
            reject(error);
          });
      });
    },
    getMenuBtn() {
      if (this.treeName === "景区场景" && this.i == 0) {
        this.tree = this.$refs.tree0[0].getCheckedNodes();
      } else if (this.treeName === "景区场景" && this.i == 1) {
        this.tree = this.$refs.tree1[0].getCheckedNodes();
      } else if (this.treeName === "景区场景" && this.i == 2) {
        this.tree = this.$refs.tree2[0].getCheckedNodes();
      } else if (this.treeName === "校园场景" && this.i == 0) {
        this.tree = this.$refs.tree0[0].getCheckedNodes();
      } else if (this.treeName === "校园场景" && this.i == 1) {
        this.tree = this.$refs.tree1[0].getCheckedNodes();
      } else if (this.treeName === "校园场景" && this.i == 2) {
        this.tree = this.$refs.tree2[0].getCheckedNodes();
      } else if (this.treeName === "社区场景" && this.i == 0) {
        this.tree = this.$refs.tree0[0].getCheckedNodes();
      } else if (this.treeName === "社区场景" && this.i == 1) {
        this.tree = this.$refs.tree1[0].getCheckedNodes();
      } else if (this.treeName === "社区场景" && this.i == 2) {
        this.tree = this.$refs.tree2[0].getCheckedNodes();
      }

      var menuBtn = {};
      var menubtn = this.tree.filter((e) => e.type == "btn");
      menubtn.forEach((e) => {
        if (!menuBtn[e.pid]) {
          var btns = [];
          menubtn.forEach((b) => {
            if (b.pid == e.pid && b.menuId) {
              btns.push(b.menuId);
            }
          });
          menuBtn[e.pid] = btns.join(",");
        }
      });
      return menuBtn;
    },
    submit(formName, v) {
      this.treeName = v;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.roleForm.roleName = this.form.name;
          this.roleForm.serverId =
            this.typeArr.length > 1 ? this.form.serverId : this.typeArr[0].id;
          if (v === "景区场景") {
            this.roleForm.menuBtn = this.getMenuBtn();
            this.roleForm.sceneId = 1;
            this.roleForm.roleId = this.$route.query.roleId;
            this.$api.role
              .editRole(this.roleForm)
              .then((d) => {
                if (d.code == 200) {
                  this.$message({
                    message: "设置成功",
                    type: "success",
                  });
                  this.addORUpdateVisible = false;
                  this.$refs.roleForm.resetFields();

                  this.rolelist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else if (v === "校园场景") {
            this.roleForm.menuBtn = {};
            this.roleForm.menuBtn = this.getMenuBtn();
            this.roleForm.sceneId = 2;
            this.roleForm.roleId = this.$route.query.roleId;

            this.$api.role
              .editRole(this.roleForm)
              .then((d) => {
                if (d.code == 200) {
                  this.$message({
                    message: "设置成功",
                    type: "success",
                  });
                  this.addORUpdateVisible = false;
                  this.$refs.roleForm.resetFields();

                  this.rolelist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            this.roleForm.menuBtn = {};
            this.roleForm.menuBtn = this.getMenuBtn();
            this.roleForm.sceneId = 3;
            this.roleForm.roleId = this.$route.query.roleId;
            this.$api.role
              .editRole(this.roleForm)
              .then((d) => {
                if (d.code == 200) {
                  this.$message({
                    message: "设置成功",
                    type: "success",
                  });
                  this.addORUpdateVisible = false;
                  this.$refs.roleForm.resetFields();

                  this.rolelist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    lookList(v) {
      let that = this;
      // that.btnlist(
      //   JSON.parse(v.$attrs.data) == "景区场景"
      //     ? 1
      //     : JSON.parse(v.$attrs.data) == "校园场景"
      //     ? 2
      //     : JSON.parse(v.$attrs.data) == "社区场景"
      //     ? 3
      //     : ""
      // );
      that.i = v.index;
      that.menulist(
        JSON.parse(v.$attrs.data) == "景区场景"
          ? 1
          : JSON.parse(v.$attrs.data) == "校园场景"
          ? 2
          : JSON.parse(v.$attrs.data) == "社区场景"
          ? 3
          : ""
      );
      if (JSON.parse(v.$attrs.data) == "景区场景" && v.index == 0) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 1,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    console.log(
                      menuBtnList,
                      "menuBtnList",
                      d.data.ifMap[key].menuInfo.menuId
                    );
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                console.log(that.menulistData, "that.menulistData");
                console.log(keys, "keys");
                let arr = ["274btn_274"];
                that.$refs.tree0[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "景区场景" && v.index == 1) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 1,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree1[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "景区场景" && v.index == 2) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 1,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree2[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "校园场景" && v.index == 0) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 2,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree0[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "校园场景" && v.index == 1) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 2,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree1[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "校园场景" && v.index == 2) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 2,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree2[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "社区场景" && v.index == 0) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 3,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree0[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "社区场景" && v.index == 1) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 3,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree1[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (JSON.parse(v.$attrs.data) === "社区场景" && v.index == 2) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 3,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree2[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      }
    },

    handleClick(v) {
      console.log(v, 5555);
    },
    btnlist() {
      //获取接口
      this.$api.system
        .btnlist({})
        .then((d) => {
          console.log(d, "按钮");
          if (d.code == 200) {
            d.data.forEach((e) => {
              e.btnId = e.btnId + "";
            });
            this.btnlistData = d.data;
            // this.menulist(a);
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeEquipmentType() {
      if (this.activeTab == 0) {
        return;
      }
      console.log(this.activeTab, "111");

      let that = this;
      // that.btnlist(
      //   JSON.parse(v.$attrs.data) == "景区场景"
      //     ? 1
      //     : JSON.parse(v.$attrs.data) == "校园场景"
      //     ? 2
      //     : JSON.parse(v.$attrs.data) == "社区场景"
      //     ? 3
      //     : ""
      // );

      that.menulist(
        that.activeTab == "景区场景"
          ? 1
          : that.activeTab == "校园场景"
          ? 2
          : that.activeTab == "社区场景"
          ? 3
          : ""
      );
      if (that.activeTab == "景区场景" && that.i == 0) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 1,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    console.log(
                      menuBtnList,
                      "menuBtnList",
                      d.data.ifMap[key].menuInfo.menuId
                    );
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                console.log(that.menulistData, "that.menulistData");
                console.log(keys, "keys");
                let arr = ["274btn_274"];
                that.$refs.tree0[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "景区场景" && that.i == 1) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 1,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree1[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "景区场景" && that.i == 2) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 1,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree2[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "校园场景" && that.i == 0) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 2,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree0[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "校园场景" && that.i == 1) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 2,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree1[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "校园场景" && that.i == 2) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 2,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree2[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "社区场景" && that.i == 0) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 3,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree0[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "社区场景" && that.i == 1) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 3,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree1[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      } else if (that.activeTab === "社区场景" && that.i == 2) {
        //获取接口
        that.$api.role
          .info({
            sceneId: 3,
            roleId: that.$route.query.roleId,
            serverId:
              this.form.serverId && this.typeArr.length > 1
                ? this.form.serverId
                : this.typeArr[0].id,
          })
          .then((d) => {
            console.log(d, "角色详情");
            if (d.code == 200) {
              that.addORUpdateVisible = true;
              that.$nextTick((e) => {
                var keys = [];
                for (var key in d.data.ifMap) {
                  if (d.data.ifMap[key].menuInfo) {
                    var menuBtnList = d.data.ifMap[key].menuBtnList;
                    if (
                      !menuBtnList ||
                      (menuBtnList && menuBtnList.length == 0)
                    ) {
                      keys.push(key + "btn_" + key);
                    } else {
                      var btnIds = [];
                      menuBtnList.forEach((e) => {
                        keys.push(key + "btn" + e.btnId);
                        btnIds.join(e.btnId);
                      });
                      if (
                        that.menulistData.findIndex(
                          (e) => e.btnIds == btnIds.join(",")
                        ) >= 0
                      )
                        keys.push(key + "btn_" + key);
                    }
                  }
                }
                that.$refs.tree2[0].setCheckedKeys(keys);
              });
            } else {
              that.$message.error(d.msg);
            }
          });
      }
    },
    menulist(a) {
      //获取接口
      this.$api.system
        .sceneMenuList({
          sceneId: a,
          serverId:
            this.form.serverId && this.typeArr.length > 1
              ? this.form.serverId
              : this.typeArr[0].id,
        })
        .then((d) => {
        console.log('获取权限',d)
          if (d.code == 200) {
            var menus = [];
            this.$store.state.menu.forEach((c) => {
              menus.push(c);
              c.children.forEach((a) => {
                menus.push(a);
              });
            });
            var r = [];
            d.data.forEach((e) => {
              r.push(e);
              if (menus.findIndex((c) => c.menuId == e.menuId) >= 0) {
                r.push(e);
              }
            });
            // console.log(1111111222, d.data);
            this.menulistData = d.data;
            this.getdata(this.menulistData);
            // console.log(11231, this.menulistData);
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // getdata(nowdata, isde) {
    //   console.log('数据组装',nowdata)
    //   console.log('数据组装判断方式',isde)
    //   // tree 数据组装
    //   var data = nowdata.filter((e) => e.pid == 0);
    //   var temp = [];
    //   data.forEach((e) => {
    //     e.children = nowdata.filter((c) => c.pid == e.menuId);
    //     // console.log(1111, e);
    //     e.disabled = e.status == 0;
    //     e.type = "menu";
    //     e.key = "menu" + e.menuId;
    //     if (e.children && e.children.length > 0) {
    //       e.children.forEach((c) => {
    //         c.disabled = c.status == 0;
    //         c.deep = 1;
    //         c.type = "menu";
    //         c.key = "menu" + c.menuId;
    //         c.children = [
    //           {
    //             type: "btn",
    //             key: c.menuId + "btn_" + c.menuId,
    //             pid: c.menuId,
    //             menuName: "查看",
    //             menuId: "",
    //           },
    //         ];
    //         if (!isde) {
    //           c.btnIds = c.btnIds ? c.btnIds.split(",") : [];
    //           c.btnIds.forEach((b) => {
    //             var btn = this.btnlistData.find((r) => r.btnId == b);
    //             if (btn) {
    //               c.children.push({
    //                 disabled: btn.status == 0,
    //                 type: "btn",
    //                 key: c.menuId + "btn" + btn.btnId,
    //                 pid: c.menuId,
    //                 menuName: btn.btnName,
    //                 menuId: btn.btnId,
    //               });
    //             }
    //           });
    //         }
    //       });
    //     }
    //     if (!isde) {
    //       e.btnIds = e.btnIds ? e.btnIds.split(",") : [];
    //       e.btnIds.forEach((b) => {
    //         var btn = this.btnlistData.find((r) => r.btnId == b);
    //         if (btn) {
    //           e.children.push({
    //             disabled: btn.status == 0,
    //             type: "btn",
    //             key: e.menuId + "btn" + btn.btnId,
    //             pid: e.menuId,
    //             menuName: btn.btnName,
    //             menuId: btn.btnId,
    //           });
    //         }
    //       });
    //     }
    //     console.log('数据',e)
    //     temp.push(e);
    //   });
    //   // console.log(temp);
    //   this.menulistTreeData = temp;
    //   console.log(this.menulistTreeData, 3333);
    // },
    getdata(nowdata, isde) {
  console.log('数据组装', nowdata);
  
  // 去重：基于 menuId 去重
  const uniqueData = [];
  const seenIds = new Set();
  
  nowdata.forEach((item) => {
    if (!seenIds.has(item.menuId)) {
      seenIds.add(item.menuId);
      uniqueData.push(item);
    }
  });
  
  var data = uniqueData.filter((e) => e.pid == 0);
  var temp = [];
  
  data.forEach((e, index) => {
    e.children = uniqueData.filter((c) => c.pid == e.menuId);
    e.disabled = e.status == 0;
    e.type = "menu";
    e.key = "menu" + e.menuId + "_" + index; // 添加索引确保唯一
    
    if (e.children && e.children.length > 0) {
      e.children.forEach((c, childIndex) => {
        c.disabled = c.status == 0;
        c.deep = 1;
        c.type = "menu";
        c.key = "menu" + c.menuId + "_" + index + "_" + childIndex; // 添加索引
        
        c.children = [
          {
            type: "btn",
            key: c.menuId + "btn_" + c.menuId + "_" + index + "_" + childIndex,
            pid: c.menuId,
            menuName: "查看",
            menuId: "",
          },
        ];
        
        if (!isde) {
              c.btnIds = c.btnIds ? c.btnIds.split(",") : [];
              c.btnIds.forEach((b) => {
                var btn = this.btnlistData.find((r) => r.btnId == b);
                if (btn) {
                  c.children.push({
                    disabled: btn.status == 0,
                    type: "btn",
                    key: c.menuId + "btn" + btn.btnId,
                    pid: c.menuId,
                    menuName: btn.btnName,
                    menuId: btn.btnId,
                  });
                }
              });
            }
      });
    }
    
    // ... 其他代码保持不变
    
    temp.push(e);
  });
  
  this.menulistTreeData = temp;
},
    filterNode(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 250px !important;
}
</style>
